import React from 'react';
import { MenuSide } from '../../components/MenuSide';
import GraficoCustoMensalEnvio from "./GraficoCustoEnvioMensal";

export default function Atendimentos() {

    return (
        <>
            <div className='row'>
                <div className='col-sm-2'>
                    <MenuSide />
                </div>
                <div className='col-sm-10'>
                    
                    <br />
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='card'
                                style={{ marginRight: '30px', }}>
                                <div className='card-header'>
                                    <div className='row'>
                                        <div className='col-sm-10' style={{ fontWeight: 700, fontSize: '25px', }}>
                                            Custo mensal dos envios
                                        </div>
                                        <div className='col-sm-2 text-end'>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <div style={{ padding: 20 }}>
                                         <GraficoCustoMensalEnvio />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </>
    );
}